import Screen from '../../components/screen';
import Container from '../../components/container';
import { services, TService } from '../../helpers/services.helper';
import ScreenTitle from '../../components/screen-title';

export default function Services() {
	const serviceRender = (service: TService) => {
		return (
			<div className={'gap-8'}>
				<div className={'space-y-3'}>
					<p className={'text-3xl pb-3'}>
						{service.name}
					</p>
					<p className={'roboto'}>
						{service.description}
					</p>
				</div>
			</div>
		);
	}

	return (
		<Screen>
			<ScreenTitle title={'Serviços'}/>

			<Container>
				<div className={'space-y-12'}>
					{services.map((service, index) => (
						<section className={'space-y-12'} key={`service_${index}`}>
							{serviceRender(service)}
							{
								index < services.length - 1 &&
                                <div className={'border-4 border-primary w-96 my-4'}></div>
							}
						</section>
					))}
				</div>
			</Container>
		</Screen>
	);
}